import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './containers/';
import './unit/const';
import './control';
import { subscribeRecord } from './unit';

subscribeRecord(store); // 将更新的状态记录到localStorage

render(
  <Provider store={store}>
    <App />
  </Provider>
    , document.getElementById('root')
);

// customizations

const hideAd = (e) => {
  const event = e || window.event
  const target = event.target || event.srcElement
  // @ts-ignore
  target.closest('.ad').remove()
}
// @ts-ignore
window.hideAd = hideAd

// show hideAd button with delay
setTimeout(() => {
  const closeBtn = document.querySelectorAll('.close-btn')[0];
  // @ts-ignore
  closeBtn.style.visibility = 'visible';
}, 7000);



// WEBPACK FOOTER //
// ./src/index.js